{
  "navigation": {
    "dashboard": "Dashboard",
    "clients": "Clients",
    "facilities": "Facilities",
    "equipment": "Equipment",
    "users": "Users",
    "reports": "Reports",
    "reportsLibrary": "Reports Library",
    "apiData": "API Data",
    "fuseAdmin": "FuSE Admin",
    "unresolvedLogs": "Unresolved Logs",
    "viewAllChangeLogs": "View All Change Logs",
    "noUnresolvedChangeLogs": "No unresolved change logs found.",
    "settings": "Settings",
    "company": "Company",
    "statements": "Statements",
    "support": "View support page",
    "adminSearch": "Quickly find Clients, Facilities, Equipment, or Users",
    "signedInAs": "Signed in as",
    "editProfile": "Edit Profile",
    "logout": "Log Out"
  }
}
